import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from "react-router-dom";
function StbReplacement() {
    const [loading, setLoading] = useState(true);
    const [stbCount, setStbCount] = useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [rowsData, setRowsData] = useState([]);
    const [allCustomer, setAllCustomer] = useState([]);
  
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const user = getCookie('user');
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ date: "", toDate: "" })
    const initialFormData = {date: "", toDate: "" }
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    if (!user) { navigate('/'); }
    function handleChange(e) {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
 const downloadCSV = () => {
  if (!allCustomer || allCustomer.length === 0) {
    alert("No data available");
    return;
  }

  const headers = [
    "Sl_No",
    "Customer_Name",
    "Date",
    "Old_STB_No",
    "New_STB_No",
    "Replacement_Amount",
    "Incentive_Amount",
    "Total_Amount",
    "Installed_By",
    "Collected_By",
    "Remarks"
  ];

  const csvRows = [];
  csvRows.push(headers.join(","));

  filteredRows.forEach((row, index) => {
    const values = [
      index + 1,
      row.customer_name,
      row.trip_date,
      row.old_stb_no,          // OLD STB
      row.new_stb_no,           // NEW STB
      row.box_amount,
      row.incentive,
      row.Total,            // total (change if you calculate separately)
      row.installed_by_name || row.installed_by || row.name,
      row.connection_by,
      row.remarks
    ];

    const safeValues = values.map(v => {
      const value = v ?? "";
      return `"${String(value).replace(/"/g, '""')}"`;
    });

    csvRows.push(safeValues.join(","));
  });

  const blob = new Blob([csvRows.join("\n")], {
    type: "text/csv;charset=utf-8;"
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `STB_Replacement_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = allCustomer.slice(indexOfFirstRow, indexOfLastRow);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(allCustomer.length / rowsPerPage);
    const filteredRows = currentRows.filter((row) => Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())));
    const handleClear = () => { setFormData(initialFormData); };
    function handleSubmit(e) {
        setIsButtonDisabled(true);
        e.preventDefault();
        console.log("Form Data:", formData); a();
        async function a() {
            try {
                const response = await axios.post('https://node.cabletvpay.in/stbReplacementSpecific', { user, formData });
                if (response.status === 200) {
                   
                    setStbCount(response.data.result.length);
                    setAllCustomer(response.data.result);
                    setIsButtonDisabled(false);
                }
            } catch (err) {
                toast.error(err.response?.data?.message || "Error fetching data");
                setIsButtonDisabled(false)
            }
        }
    }
    const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/stbReplacementGetInfo', { user });
            if (response.status === 200) {
            
                setStbCount(response.data.allCustomer.length);
             
                setAllCustomer(response.data.allCustomer);
             
            }
        } catch (err) { setError(err.response?.data?.message || "Error fetching data"); }
        finally { setLoading(false); }
    };
    const stb = useMemo(() => allCustomer.map(row => parseInt(row.serial_num, 10)), [allCustomer]);
    const handleCopyToClipboard = () => { navigator.clipboard.writeText(stb).then(() => { toast.info(`${stbCount} STB numbers copied`); }).catch((error) => { toast.warning("not copied: " + error); }); };
    useEffect(() => { fetchUserData(); }, []);
    if (loading) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" wrapperStyle={{}} wrapperClass="" />
        </div></div>)
    if (error) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>
          <img src="../asset/img/errorPage.jpg" alt="" style={{ height: "20rem" }} />
        </div></div>);

    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <div className="my-3">
                    <div className="fs-4 valuesDec h4">STB REPLACEMENT DETAILS</div>
                </div>
                <hr />
                <div className="card mt-3 mb-2 p-2">
                    <div className="card-header mb-1 text-center py-1">
                        <h5>Modify Customer STB</h5>
                    </div>
                    <div className="border-1 px-1">
                        <form action="/allCustomer" method="get">
                            <div className="row mx-3 d-flex justify-content-center">

                                <div className="col-lg-4 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="stboldbox" className="text-center valuesDec text-navy">Choose Old Box Type</label>
                                        <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="stboldbox" name="stboldbox">
                                            <option value="all">All</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="oldstbnumber" className="text-center valuesDec text-navy">Enter Old Stb Number</label>
                                        <input type="text" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="oldstbnumber" id="oldstbnumber" placeholder="Old Stb Number" />
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="replacement" className="text-center valuesDec text-navy">Enter Replacement Number</label>
                                        <input type="text" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="replacement" id="replacement" placeholder="Replacement amount" />
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="newstb" className="text-center valuesDec text-navy">New Stb Number</label>
                                        <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="newstb" name="newstb">
                                            <option value="all">All</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="icentive" className="text-center valuesDec text-navy">Enter Incentive Number</label>
                                        <input type="text" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="icentive" id="icentive" placeholder="Incentive amount" />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="remarks" className="text-center valuesDec text-navy">Remarks</label>
                                        <input type="textarea" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="remarks" id="remarks" placeholder="Remarks..." />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-6 col-12">
                                    <div className="d-flex justify-content-end ">
                                        <input type="submit" className="btn btn-info filterBtn rounded text-light h-100 pb-4 pb-lg-1 " value="Add Stb Charge" />
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>
                </div>
                <div className="mt-1 mb-2">
                    <div className="card info-box border-0 px-1">

                         <form method="get" onSubmit={handleSubmit}>
                            <div className="row mx-3 d-flex justify-content-center">

                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="date" className="text-center valuesDec text-navy">From</label>
                                        <input type="date" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="date" id="date"  value={formData.date} onChange={handleChange}/>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="toDate" className="text-center valuesDec text-navy">To</label>
                                        <input type="date" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="toDate" id="toDate"  value={formData.toDate} onChange={handleChange}/>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-6 col-12 mb-2 d-flex justify-content-center pt-lg-4 mt-lg-2 pt-2">
                                    <input type="submit" className="btn btn-info filterBtn rounded text-light h-75 pb-3 pb-lg-1 w-100" value="Filter" />
                                </div>
                           <div className="col-lg-2 col-md-6 col-12 mb-2 d-flex justify-content-center pt-lg-4 mt-lg-2 pt-2">
                                <button type="button" className="btn border-0 bg-danger filterBtn text-light  h-75 pb-3 pb-lg-1 w-100" onClick={handleClear} > Clear </button>
                            </div>
                            </div>

                        </form>
                    </div>
                </div>

                <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            {/* Header Title */}
                            <div className="col-lg-4">
                                <div className="text-left mb-lg-0 w-50">
                                    <h4 className="pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                                </div>
                            </div>
                            {/* Actions */}
                            <div className="col-lg-8 mt-1">
                                <span>
                                    <div className="row w-auto">
                                        {/* Search Bar */}
                                        <div className="col-11 col-lg-6">
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control text-navy bg-light border-0 px-1 py-0"
                                                    placeholder="Search..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    style={{ borderRadius: "5px 0 0 5px" }}
                                                />
                                                <span
                                                    className="input-group-text bg-light text-navy border-0 px-2"
                                                    id="basic-addon1"
                                                    style={{ borderRadius: "0 5px 5px 0" }}
                                                >
                                                    <i className="fas fa-search" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                            <div className="d-flex justify-content-end">
                                                <div className=" btn-group">
                                                    <button
                                                        onClick={downloadCSV}
                                                        className="btn btn-dark border-right px-lg-3 px-5"
                                                    >
                                                        <i className="fas fa-download" /> Download
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>


                    <div className="card-body p-0">
                        <table id="myTable" className="table table-bordered table-responsive-lg">
                            <thead className="bg-gradient-navy">
                                <tr>
                                
                                    <th>Sl_No</th>

                                    <th>Name</th>
                                    <th>Date</th>

                                    <th>Old STB_no</th>
                                    <th>New STB_no</th>
                                    <th>Replacemnet Amount</th>
                                    <th>Incentive Amount</th>
                                    <th>Total</th>
                                    <th>Installed By</th>
                                    <th>Amount Collected By</th>

                                    <th>Remarks</th>

                                    <th>Edit</th>

                                </tr>
                            </thead>
                            <tbody>
  {filteredRows.length > 0 ? (
    filteredRows.map((row, index) => (
      <tr key={index}>
        <td>{indexOfFirstRow + index + 1}</td>

        <td>{row.customer_name}</td>
        <td>{row.trip_date}</td>

        <td>{row.old_stb_no}</td>
        <td>{row.new_stb_no}</td>

        <td>{row.box_amount}</td>
        <td>{row.incentive}</td>
        <td>{row.Total}</td>

        <td>{row.installed_by_name}</td>
        <td>{row.connection_by}</td>

        <td>{row.remarks}</td>

        <td>
          <div className="d-flex justify-content-center">
            <Link to="/home">
              <button className="btn text-fuchsia">
                <i className="fas fa-edit"></i>
              </button>
            </Link>
          </div>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="12">No results found</td>
    </tr>
  )}
</tbody>

                        </table>
                    </div>
                    <div className="card-footer">
                        <div className="d-flex justify-content-end">
                            <div className="pagination btn-group border-light">
                                <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                                <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-light active" : "btn-dark"} border-left`} > 1 </button>
                                {currentPage > 3 && <span className="mx-1">...</span>}
                                {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                                    .filter((page) => page > 1 && page < totalPages)
                                    .map((page) => (
                                        <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-light active" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                                    ))}
                                {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                                {totalPages > 1 && (
                                    <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-light active" : "btn-dark"} border-right`} > {totalPages} </button>
                                )}
                                <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
              
            </div>
        </div>
    );
}

export default StbReplacement;
